








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AppCardSidebarLayout extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/layouts/cardlayouts/CardSidebarLayout/AppCardSidebarLayout.vue